<h2 mat-dialog-title>{{ 'Ecommerce.POS.switch_table_tile' | transloco }}</h2>
<div mat-dialog-content>
    <mat-form-field class="full-width">
        <mat-label>{{ 'Ecommerce.POS.table_name' | transloco }}</mat-label>
        <mat-select
            [(value)]="selectedTable"
            (openedChange)="onSelectOpened($event)"
            [disableOptionCentering]="true"
        >
            <!-- Filtered options -->
            <mat-option *ngFor="let table of filteredTables" [value]="table">
                {{ table.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button [disabled]="loading" (click)="onCancel()">{{ 'cancel' | transloco }}</button>
    <button
        mat-raised-button
        color="primary"
        [disabled]="!selectedTable || loading"
        (click)="onSave()"
    >
        {{ 'save' | transloco }}
    </button>
</div>
